import './App.css';
import Body from './components/Body';
import SectionTwo from './components/SectionTwo';
import Footer from './components/Footer';
import Show from './components/Projects';
import Header from './components/Header';
function App() {
  return (
    <div className="bg-[#050810]">
      <Header />
      <Body />
      <SectionTwo />
      <Show />
      <Footer />
      
    </div>
  );
}

export default App;
